var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.10536 9.40937L2 10.5914L6.71446 15L16.1132 4.05428L14.8854 3L6.58663 12.6647L3.10536 9.40937Z",
    fill: "#33A000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconGreen);
export default __webpack_public_path__ + "static/media/tick-icon-green.88ab3f5b2950cf80f3b70804b8f231d7.svg";
export { ForwardRef as ReactComponent };